import { environment } from 'environments/environment';
import { ExtendedAxiosResponse, apiClient } from 'helpers/apiClient';

export const api = {
  downloadEBillDocument: (
    url: string,
    invoiceNumber: string,
    serviceId?: string,
    serviceNo?: string,
    claimId?: string,
    format?: string,
    type?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/download/ebillDownload`, {
      responseType: 'blob',
      withCredentials: !environment.urlConfig.eBillDownloader.mockEnabled,
      params: {
        invoicenumber: invoiceNumber,
        serviceid: serviceId,
        serviceno: serviceNo,
        claimid: claimId,
        format: format,
        type: type,
      },
    }),
};
